/* eslint-disable no-case-declarations */
import { THEME_TOGGLE } from '../constants/ActionTypes';
import storage from '../storage';

const initialTheme = storage.getItem('isDarkTheme') || false;

const theme = (state = { isDark: initialTheme }, action) => {
  switch (action.type) {
    case THEME_TOGGLE:
      let { isDark } = state;
      isDark = !isDark;

      storage.setItems({
        isDarkTheme: isDark,
      });

      return { ...state, isDark };
    default:
      return state;
  }
};

export default theme;
